module.exports = __webpack_public_path__ + "static/media/4z_website_logo_sup_thkpu.e87a9472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4z_website_logo_sup_thkpu.jpg
// module id = 79
// module chunks = 0